import { CRICKET_WIDGET } from "@api/apiRoutes";

export const generateWidgetUrl = (dataKey: string, key: string) => {
    return `${CRICKET_WIDGET}/${dataKey}/${key}`;
};
